<template>
  <element>
    <AppBar :title="title" />
    <v-container class="pt-0">
      <v-row no-gutters class="d-flex justify-content-center">
        <v-icon class="page-icon mr-2" color="#2e384d" size=60>mdi-car</v-icon>
        <v-icon class="page-icon ml-2" color="#2e384d" size=50>mdi-barcode-scan</v-icon>
      </v-row>
      <p class="desc">{{ $t('enterCarVIN.description') }}</p>
      <form action="#" @submit.prevent="submit">
        <div class="input-control barcode-scan">
          <StreamBarcodeReader @decode="onDecode"></StreamBarcodeReader >
        </div>
        <LabelTextField 
          ref="vin"
          class="mt-3" 
          :label="$t('enterCarVIN.vin')" 
          required
        ></LabelTextField>
        <v-btn
          class="submit-btn"
          type="submit"
          height="45px"
          color="#033e8c"
          depressed
          block
          dark
          >
          {{ title }}
        </v-btn>
      </form>
    </v-container>
  </element>
</template>

<script>
import AppBar from "@/components/common/AppBar.vue"
import LabelTextField from "@/components/common/LabelTextField.vue"
import { StreamBarcodeReader  } from 'vue-barcode-reader';

export default {
  name: "EnterCarVINPage",
  props: {},
  components: {
    AppBar,
    LabelTextField,
    StreamBarcodeReader
  },
  data() {
    return {
      title: '',
      valid: false,
      scanned: ''
    }
  },
  methods: {
    onDecode(decodedString) {
      if (this.scanned != decodedString) {
        this.$refs.vin.textValue = decodedString
        this.scanned = decodedString
      }
    },
    submit() {
      const variables = {
        "variables": {
          "vin": {
            "value": this.$refs.vin.textValue
          }
        }
      }

      const taskId = this.$store.getters.getCurrentTask?.id

      if (taskId) {
        this.$store.dispatch('completeTask', { taskId, variables })
        .then(response => {
          console.log("Task completed successfully!", taskId, response)
        })
        .catch(error => {
          console.log("Failed completing task!", taskId, error)
        })
      }
    }
  },
  created() {
    this.title = this.$store.getters.getCurrentTask.taskName
  }
}
</script>

<style scoped>
.barcode-scan {
  border-radius: 0.3125rem;
  border: 1px solid #e0e7ff;
  padding: 1rem 0;
}
</style>